import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

// Create axios instance with default config
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests if available
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle 401 responses (unauthorized)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth API
export const authAPI = {
  login: (email, password) => api.post('/auth/login', { email, password }),
  register: (userData) => api.post('/auth/register', userData),
  getCurrentUser: () => api.get('/auth/me'),
};

// Leads API
export const leadsAPI = {
  createLead: (leadData) => api.post('/leads', leadData),
  getLeads: (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.lead_type) params.append('lead_type', filters.lead_type);
    if (filters.status) params.append('status', filters.status);
    return api.get(`/leads?${params.toString()}`);
  },
  getLead: (leadId) => api.get(`/leads/${leadId}`),
  updateLead: (leadId, updateData) => api.put(`/leads/${leadId}`, updateData),
  deleteLead: (leadId) => api.delete(`/leads/${leadId}`),
  getStats: () => api.get('/leads/stats/summary'),
};

// Notes API
export const notesAPI = {
  createNote: (leadId, content) => api.post(`/leads/${leadId}/notes`, { content }),
  getNotes: (leadId) => api.get(`/leads/${leadId}/notes`),
};

// Users API
export const usersAPI = {
  getUsers: () => api.get('/users'),
};

export default api;
